import { Auth0Provider } from '@auth0/auth0-react';
import type { ReactNode } from 'react';
import { env } from '../env';

export function DhuttuAuth0Provider({ children }: { children: ReactNode }) {
  return (
    <Auth0Provider
      domain={env.auth0Domain}
      clientId={env.auth0ClientId}
      cacheLocation="memory"
      useRefreshTokens={true}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: env.auth0Audience,
        scope: 'openid profile email',
      }}
    >
      {children}
    </Auth0Provider>
  );
}
